module.exports = __webpack_public_path__ + "img/comoros.9adea2e.webp";